/* eslint-disable react-hooks/exhaustive-deps */
import logoImg from '../../assets/logo.svg';
import capaImg from '../../assets/teo.png';
import { useNavigate } from 'react-router-dom';

import { Container, FormContainer, InputBlock, Left } from './styles';
import { Link } from 'react-router-dom';
import { FormEvent, useState } from 'react';
import { toast } from 'react-toastify';
import { useUser } from '../../hooks/useUser';
import Cookies from 'js-cookie';
import { Loader } from '../../components/Loader/Loader';

export function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { handleSignInUser, loadUser, setCurrentCompany } = useUser();
  const [username, setUser] = useState('');
  const [password, setPassword] = useState('');

  async function submit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await handleSignInUser(username, password);
      const access_token = localStorage.getItem('access_token');
      const { credors } = await loadUser(access_token!);
      setCurrentCompany(credors[0]);
      Cookies.set('isAuthenticated', 'true');
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      toast.error('Falha ao fazer login', {
        position: 'top-right',
      });
      navigate('/');
    } finally {
      setLoading(false);
    }
  }
  const urlParams = new URLSearchParams(window.location.search);
  const message = urlParams.get('message');
  if (message) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  } else {
    return (
      <Container>
        {loading && <Loader />}
        <Left>
          <div className="header">
            <img src={logoImg} alt="Quita tudo" />
          </div>
          <div className='theo'>
            <img src={capaImg} alt="Theo" />
            <h1>Painel do Cliente</h1>
          </div>
        </Left>

        <FormContainer
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <h1>Acessar</h1>
          <form onSubmit={(e) => submit(e)}>
            <InputBlock>
              <input
                type="text"
                placeholder="Usuário"
                value={username}
                onChange={(e) => setUser(e.target.value)}
                required
              />
            </InputBlock>

            <InputBlock>
              <input
                type="password"
                value={password}
                placeholder="Senha"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </InputBlock>

            <button
              type="submit"
              disabled={
                username.length === 0 || password.length === 0 ? true : false
              }
              style={
                username.length === 0 || password.length === 0
                  ? {
                      cursor: 'not-allowed',
                    }
                  : {}
              }
            >
              Acessar
            </button>
          </form>
          <Link to="/reset-password">
            <span>Esqueceu a senha?</span>
          </Link>
        </FormContainer>
      </Container>
    );
  }
}
